import React from "react";

const TabPanel = ({ children, value, name, style: styleProp, ...rest }) => {
	// style inline tem prioridade sobre className (display:flex do MUI)
	const style = value !== name
		? { ...styleProp, display: "none" }
		: styleProp;

	return (
		<div
			role="tabpanel"
			id={`simple-tabpanel-${name}`}
			aria-labelledby={`simple-tab-${name}`}
			{...rest}
			style={style}
		>
			{children}
		</div>
	);
};

export default TabPanel;
